export const environment = {
  production: true,
  baseUrl: "https://api.bancreach.com/",
  imageUrl: "https://api.bancreach.com",
};
